export enum CheckoutStatus {
    PENDING = 1,
    PROCESSING = 2,
    QUEUED = 3,
}
